import Vue from 'vue'
import Vuex from 'vuex'
// import axios from 'axios' // remove comment if yu needed
import Crud from '../crud'
const model = (payload) => ({
  // columns
  id: payload.id,
  name: payload.name,
  description: payload.description
})
var crud = new Crud('ProductCategories', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  productCategories: []
}

const mutations = {
  ...crud.mutations
}

const actions = {
  ...crud.actions
}

const getters = {
  ...crud.getters,
  productCategories: state => state.productCategories
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
